import { render } from "./productInfo.vue?vue&type=template&id=555de132&scoped=true"
import script from "./productInfo.vue?vue&type=script&lang=js"
export * from "./productInfo.vue?vue&type=script&lang=js"

import "./productInfo.vue?vue&type=style&index=0&id=555de132&scoped=true&lang=css"

import exportComponent from "C:\\file_data\\zxh\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555de132"]])

export default __exports__